import { Color, Spacing } from '@persona-id/design-tokens';
import { XIcon } from '@persona-id/design-tokens/icons';
import { ComponentPropsWithoutRef, useState } from 'react';

import Attribute, { AttributeGrid } from 'design-system/components/Attribute';
import Button, { IconButton } from 'design-system/components/Button';
import Input from 'design-system/components/Input';
import { Paragraph } from 'design-system/components/Text';

interface CustomHttpHeadersProps
  extends Omit<ComponentPropsWithoutRef<'input'>, 'onChange' | 'value'> {
  value?: Record<string, string>;
  disabled?: boolean;
  error?: string;
  onChange: (values: Record<string, string>) => void;
}

const DashboardInquiriesView = ({
  value: customHttpHeaders = {},
  disabled,
  error,
  onChange,
}: CustomHttpHeadersProps) => {
  // TODO: convert this to `react-hook-form`, see https://www.notion.so/withpersona/ef8fecd8bbf84876a476c21afa01d923
  const [newHttpHeaderKey, setNewHttpHeaderKey] = useState<string>('');
  const [newHttpHeaderValue, setNewHttpHeaderValue] = useState<string>('');

  const handleRemoveHttpHeader = (header: string) => {
    const { [header]: _, ...remainingHeaders } = customHttpHeaders;
    onChange(remainingHeaders);
  };

  const handleAddHttpHeader = () => {
    if (newHttpHeaderKey === '' || newHttpHeaderValue === '') {
      return;
    }
    onChange({ ...customHttpHeaders, [newHttpHeaderKey]: newHttpHeaderValue });
    setNewHttpHeaderKey('');
    setNewHttpHeaderValue('');
  };

  return (
    <>
      <AttributeGrid>
        {Object.entries(customHttpHeaders).map(([httpHeader, httpHeaderValue], idx) => (
          <div key={`custom-http-header__attributes-${idx}`}>
            <Attribute
              label={httpHeader}
              toggleable
              value={httpHeaderValue}
              key={idx}
              right={
                <IconButton
                  aria-label={`Remove ${httpHeader} header`}
                  onClick={() => {
                    handleRemoveHttpHeader(httpHeader);
                  }}
                  id={`custom-http-header__button--remove-${idx}`}
                >
                  <XIcon />
                </IconButton>
              }
            />
          </div>
        ))}
      </AttributeGrid>
      <div style={{ flexDirection: 'row', display: 'flex', gap: Spacing['1'] }}>
        <Input
          value={newHttpHeaderKey || ''}
          placeholder='HTTP Header Name'
          disabled={disabled}
          onChange={(event) => {
            setNewHttpHeaderKey(event.target.value);
          }}
        />
        <Input
          value={newHttpHeaderValue || ''}
          placeholder='HTTP Header Value'
          disabled={disabled}
          style={{ flexGrow: 1 }}
          onChange={(event) => setNewHttpHeaderValue(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleAddHttpHeader();
            }
          }}
        />
        <Button
          onClick={handleAddHttpHeader}
          id='custom-http-header__button--add'
          disabled={newHttpHeaderKey === '' || newHttpHeaderValue === ''}
          style={{ width: 'auto' }}
        >
          Add
        </Button>
      </div>
      {error && <Paragraph style={{ color: Color.CoreRed800 }}>{error}</Paragraph>}
    </>
  );
};

export default DashboardInquiriesView;
